module.exports = __webpack_public_path__ + "img/right-anger-bubble.e880e1eb.png";